import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@emotion/react';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';

import Alert, { useAlert } from 'components/snacks/Alert';
import CollapseUserFactors from 'components/collapse/UserFactors'

import { factorColumns, numSeperator } from 'utils/DataBase';
import { axiosInstance, getFactorList } from 'api/Api';
import Loading from 'layout/Loading';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  useEffect(() => {
    const selector1 = document.querySelector('#factorPagination p');
    if (selector1) {
      selector1.classList.add('yekan-font');
      selector1.innerHTML = 'ردیف در هر صفحه';
    }
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        sx={{ mr: 2.5 }}
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>

      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};

export default function StickyHeadTable() {
  const [data, setData] = useState(null);
  const [len, setLen] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState('');
  const [filteredInvoices, setFilteredInvoices] = useState(data);
  useEffect(() => {
    setFilteredInvoices(data);
  }, [data]);

  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);

  const [bankDetail, setBankDetail] = useState({
    card_number: '5892-1013-0981-0436',
    shaba_number: 'IR840150000003101003635941',
    owner_name: 'فاطمه بقائی فر',
    bank_name: 'بانک سپه'
  });
  const [selectFactor, setSelectFactor] = useState('');
  const [modalDetail, setModalDetail] = useState({
    show: false,
    type: 1,
    loading: false
  });

  const handleInputChange = (e) => {
    const searchTerm = e.target.value;
    console.log(searchTerm)
    console.log('data: ',data)
    setSearch(searchTerm);

    if (!searchTerm) {
      setFilteredInvoices(data);
    } else {
      const filteredInvoices = data.filter(
        (item) =>
          String(item.invoice_no).toLowerCase().includes(searchTerm.toLowerCase()) ||
          String(item.invoice_date).toLowerCase().includes(searchTerm.toLowerCase()) ||
          String(item.service_name).toLowerCase().includes(searchTerm.toLowerCase())
      );
      console.log('filteredInvoices: ',filteredInvoices)

      setFilteredInvoices(filteredInvoices);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const modalShower = (row) => {
    setModalDetail({
      show: true,
      type: row?.payment_method,
      loading: false,
      title: 'جزئیات پرداخت',
    });
    setSelectFactor(row?.invoice_no);
  };

  useEffect(() => {
    setLoading(true);
    getFactorList((isOk, data) => {
      if (isOk) {
        setData(data.factors);
        setLen(data.factors.length);
        setBankDetail({
          card_number: data.card_no,
          shaba_number: data.shaba_no,
          owner_name: data.account_name,
          bank_name: data.account
        });
        setLoading(false);
      } else {
        alertStore.AddAlert({
          key: '400',
          message: data,
          severity: 'error',
          auto_hide: true
        });
      }
    });
  }, []);

  const copyText = (txt) => {
    navigator.clipboard.writeText(txt);
    alertStore.AddAlert({
      key: 'copy',
      message: 'با موفقیت کپی شد',
      severity: 'success',
      auto_hide: true
    });
  };

  const paymentFactor = () => {
    const formData = new FormData();
    formData.append('invoice_id', selectFactor);
    setModalDetail({ ...modalDetail, loading: true });
    axiosInstance()
      .post('/online-payment', formData)
      .then((r) => {
        if (r.data.status === 200) {
          return window.location.replace(r.data.url);
        } else {
          setModalDetail({ ...modalDetail, loading: false, show: false });

          alertStore.AddAlert({
            key: '400',
            message: r.data.msg,
            severity: 'error',
            auto_hide: true
          });
        }
      });
  };

  const [checkbox, setCheckbox] = useState(false)
  const handleCheckbox = () => {
    setCheckbox(true)
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Paper
            className="normal-shadow rounded-lg bg-white my-5 py-2 px-2 px-lg-10 py-lg-4"
            id={'serviceCard'}
            elevation={1}
            sx={{ overflow: 'hidden' }}
          >
            <div
              className="card-header d-flex justify-content-between align-items-center py-3 gap-2 gap-md-5"
              data-select2-id="select2-data-133-8g4r"
            >
              <div className="card-title">
                <div className="d-flex align-items-center position-relative my-1">
                  <h6>لیست فاکتورهای من</h6>
                  <input
                    type="search"
                    placeholder="جستجو..."
                    className="search-inp border-none"
                    value={search}
                    onChange={handleInputChange}
                  />
                  {/*{ checkbox ?*/}
                  {/*   <>*/}
                  {/*   <Link*/}
                  {/*      to={`/factors/all-factor-details`}*/}
                  {/*      className={*/}
                  {/*        `btn btn-success btn-sm yekan-font mr-20`*/}
                  {/*      }*/}
                  {/*    >*/}
                  {/*      پرداخت*/}
                  {/*    </Link>*/}
                  {/*  <button onClick={()=>setCheckbox(false)} className='btn btn-sm btn-primary btn-light btn-active-primary mx-2'>لغو</button>*/}
                  {/*  </>*/}
                  {/*  :*/}
                  {/*  <button onClick={handleCheckbox} className='btn btn-sm btn-primary btn-light btn-active-primary mx-5'>پرداخت چند تایی</button>*/}
                  {/*}*/}
                </div>
              </div>
            </div>
            <TableContainer className="d-none d-md-block">
              <Table stickyHeader aria-label="sticky table">
                <TableHead sx={{ BackgroundColor: '#eaeaea' }}>
                  <TableRow>
                  {factorColumns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          width: column.width ? column.width : 'auto',
                          minWidth: column.minWidth ? column.minWidth : 'auto',
                          fontFamily: 'yekan',
                          fontWeight: 700,
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredInvoices &&
                    filteredInvoices
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                            style={{
                              backgroundColor: index % 2 === 0 ? '#f3f3f3' : ''
                            }}
                          >
                            {factorColumns?.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  sx={{ fontFamily: 'yekan' + '!important', backgroundColor: (row['status'] === '0') ? 'rgba(255, 49, 85, 0.04)' : '' }}
                                >
                                  {/* column.id === 'status' &&
                                  row['status'] === '1' && */}
                                  {column.id === 'id' && (
                                    <>
                                      {/* {checkbox ? */}
                                        <input style={{opacity:checkbox ? 1 : 0}} type='checkbox' className={`factor-checkbox factor-animation ${row['status'] !== '0' && "hidden"}`} />
                                      {/* : */}
                                      <span style={{opacity:checkbox ? 0 : 1}} className='factor-animation'>
                                        {index + 1 + page * rowsPerPage}
                                      </span>
                                      {/* } */}
                                    </>
                                  )}

                                  {column.id === 'detail' && (
                                    <Link
                                      to={`/factors/factor-print-${row.invoice_no}/`}
                                      className={'text-primary'}
                                    >
                                      <span className={'me-2'}>مشاهده</span>
                                      <span className="svg-icon svg-icon-2 svg-icon-primary">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          style={{
                                            transform: 'rotate(180deg)'
                                          }}
                                          width="18"
                                          height="18"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x="18"
                                            y="13"
                                            width="13"
                                            height="2"
                                            rx="1"
                                            transform="rotate(-180 18 13)"
                                            fill="#009ef7"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="#009ef7"
                                          />
                                        </svg>
                                      </span>
                                    </Link>
                                  )}
                                  {column.id === 'status' &&
                                    row['status'] === '0' && (
                                      // !checkbox &&
                                        <Link
                                          style={{opacity:checkbox ? 0 : 1}}
                                          to={`/factors/payment/${row.invoice_no}/`}
                                          className={
                                            `btn btn-success btn-sm yekan-font factor-animation`
                                          }
                                          >
                                          پرداخت
                                        </Link>
                                    )}
                                  {column.id === 'status' &&
                                    row['status'] === '1' && (
                                      <span
                                        className={
                                          'badge badge-light-success my-2'
                                        }
                                      >
                                        پرداخت شده
                                      </span>
                                    )}
                                  {column.id === 'status' &&
                                    row['status'] === '2' && (
                                      <span
                                        className={
                                          'badge badge-light-primary my-2'
                                        }
                                      >
                                        تحویل شده
                                      </span>
                                    )}
                                  {column.id === 'status' &&
                                    row['status'] === '3' && (
                                      <span
                                        className={
                                          'badge badge-light-danger my-2'
                                        }
                                      >
                                        لغو شده
                                      </span>
                                    )}
                                  {((column.id === 'ref_id' && row['ref_id']) ||
                                    (column.id === 'factor_no' &&
                                      row['factor_no'] !== '0')) && (
                                    <span>{value}</span>
                                  )}
                                  {((column.id === 'ref_id' &&
                                    !row['ref_id']) ||
                                    (column.id === 'factor_no' &&
                                      row['factor_no'] === '0')) && (
                                    <span>---</span>
                                  )}
                                  {column.id !== 'detail' &&
                                    column.id !== 'status' &&
                                    column.id !== 'id' &&
                                    column.id !== 'ref_id' &&
                                    column.id !== 'factor_no' &&
                                    column.id !== 'total_payment' && (
                                      <div dangerouslySetInnerHTML={{__html: value}}></div>
                                    )}
                                  {column.id === 'total_payment' && (
                                    <span>
                                      {numSeperator(value)}&nbsp; ریال
                                    </span>
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                </TableBody>
              </Table>
            </TableContainer>
            <TableContainer className="d-none d-md-block">
              <Table>
                <TableHead />
                <TableBody>
                  <TableRow>
                    <TablePagination
                      id={'factorPagination'}
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: 'All', value: 1000 }
                      ]}
                      colSpan={4}
                      count={len}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: {
                          'aria-label': 'rows per page'
                        },
                        native: true
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                      style={{ display: 'flex' }}
                    />
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {/* mobile items */}
            {data &&
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <>
                      <div className="d-md-none mt-3" key={`user-factors-${index}`}>
                        <CollapseUserFactors
                          item={row}
                          columns={factorColumns}
                          pay={modalShower}
                        />
                      </div>
                    </>
                  );
                })}
          </Paper>
          {/* ******************* MODAL ***************************** */}
          {modalDetail.show && (
            <>
              <div className="modal fade show d-block" id="transferModal">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        {modalDetail.title}
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() =>
                          setModalDetail({
                            ...modalDetail,
                            show: false
                          })
                        }
                      ></button>
                    </div>
                    {modalDetail.loading ? (
                      <>
                        <div className="modal-body text-center">
                          <Box
                            sx={{ display: 'flex', marginLeft: '15px' }}
                            className={'mx-auto'}
                          >
                            <CircularProgress className={'mx-auto'} />
                          </Box>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="modal-body">
                          {modalDetail.type === 1 ? (
                            <>
                              <div className="text-center">
                                <h5 className={'badge badge-primary w-100'}>
                                  شماره کارت
                                </h5>
                                <div
                                  className={
                                    'd-flex justify-content-between align-items-center'
                                  }
                                >
                                  <button
                                    onClick={() =>
                                      copyText(bankDetail.card_number)
                                    }
                                    className={'btn btn-sm'}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-clipboard"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                                      <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                                    </svg>
                                  </button>
                                  <h4 className={'m-0 ms-2'}>
                                    {bankDetail.card_number}
                                  </h4>
                                </div>
                                <h5
                                  className={'badge badge-primary mt-3 w-100'}
                                >
                                  شماره شبا
                                </h5>
                                <div
                                  className={
                                    'd-flex justify-content-between align-items-center'
                                  }
                                >
                                  <button
                                    onClick={() =>
                                      copyText(bankDetail.shaba_number)
                                    }
                                    className={'btn btn-sm'}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-clipboard"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                                      <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                                    </svg>
                                  </button>
                                  <h4 className={'m-0 ms-2'}>
                                    {bankDetail.shaba_number}
                                  </h4>
                                </div>
                                <h5
                                  className={'badge badge-primary mt-3 w-100'}
                                >
                                  به نام
                                </h5>
                                <div
                                  className={
                                    'd-flex justify-content-between align-items-center'
                                  }
                                >
                                  <h4 className={'m-0 ms-2'}>
                                    {bankDetail.owner_name}
                                  </h4>
                                  <h4 className={'m-0'}>
                                    {bankDetail.bank_name}
                                  </h4>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <h5>
                                <span>آیا از پرداخت فاکتور به شماره</span>
                                <span className={'mx-1'}>{selectFactor}</span>
                                <span>اطمینان دارید؟</span>
                              </h5>
                            </>
                          )}
                        </div>
                        {modalDetail.type === 2 && (
                          <div className={'modal-footer'}>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() =>
                                setModalDetail({
                                  ...modalDetail,
                                  show: false
                                })
                              }
                            >
                              خیر
                            </button>
                            <button
                              type={'button'}
                              className={'btn btn-success'}
                              onClick={paymentFactor}
                            >
                              پرداخت
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="modal-backdrop fade show"
                onClick={() =>
                  setModalDetail({
                    ...modalDetail,
                    show: false
                  })
                }
              ></div>
            </>
          )}
        </>
      )}
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </>
  );
}
